<template>
    <section class="page-dashbord-offercode pt-3">
        <app-loading :isFull="true" v-if="isLoading" />
        <div class="container">
            <div class="row">
                <div class="col">
                    <header class="text-right mb-4">
                        <h1 class="font-20">
                            کد تخفیف جدید
                        </h1>
                    </header>
                </div>
            </div>
            <form class="wrapper-form row shadow py-4 mb-5" @submit.prevent="submitForm" data-vv-scope="offerCodeForm">
                <div class="col-lg-3 col-12">
                    <div class="group-form">
                        <label v-if="!offerCodeForm.course">انتخاب دوره</label>
                        <select v-validate="'required'" name="course" v-model="offerCodeForm.course">
                            <option value="'انتخاب دوره'" selected disabled>انتخاب دوره</option>
                            <option v-for="(option,index) in list" :value="option.id" :key="index">
                                {{option.course_title}}
                            </option>
                        </select>
                        <span v-if="errors.has('offerCodeForm.course')" class="is-danger">فیلد نباید خالی باشد</span>
                    </div>
                </div>
                <div class="col-lg-3  col-12">
                    <div class="group-form ">
                        <strong class="text-left ltr d-inline-block holder" v-if="offerCodeForm.code === ''">T-</strong>
                        <input type="text" v-validate="'required'" name="code" :class="{active:offerCodeForm.code != ''}" v-model="offerCodeForm.code">
                        <span class="bar"></span>
                        <label>کد تخفیف</label>
                        <span v-if="errors.has('offerCodeForm.code')" class="is-danger">فیلد نباید خالی باشد</span>
                    </div>
                </div>
                <div class="col-lg-3  col-12">
                    <div class="group-form ">
                        <input type="tel" v-validate="'required'" name="off_capacity" :class="{active:offerCodeForm.off_capacity != ''}" v-model="offerCodeForm.off_capacity">
                        <span class="bar"></span>
                        <label class="font-12">ظرفیت(تعداد نفرات)</label>
                        <span v-if="errors.has('offerCodeForm.off_capacity')" class="is-danger">فیلد نباید خالی باشد</span>
                    </div>
                </div>
                <div class="col-lg-3  col-12">
                    <div class="group-form ">
                        <input type="tel" v-validate="'required'" name="off_percentage" :class="{active:offerCodeForm.off_percentage != ''}" v-model="offerCodeForm.off_percentage">
                        <span class="bar"></span>
                        <label class="font-12">درصد تخفیف (فقط عدد وارد شود)</label>
                        <span v-if="errors.has('offerCodeForm.off_percentage')" class="is-danger">فیلد نباید خالی باشد</span>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-action">
                        <button class="font-16 px-5 py-2 bttn-fill bttn bttn-success" v-ripple>
                            ذخیره
                        </button>
                    </div>
                </div>
            </form>
            <div class="row">
                <div class="col">
                    <header class="text-right mb-4">
                        <h2 class="font-20">
                            لیست کدهای تخفیف
                        </h2>
                    </header>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="shadow shadow-sm  mb-5 bg-white" v-if="listCode.length">
                        <b-table stacked="lg" :fields="fieldsItems" :items="listCode" class="text-center">
                            <template v-slot:cell(action)="row" >
                                <div class="text-center">
                                    <button @click.stop="remove(row)" class="font-16 px-5 py-2 bttn-fill bttn bttn-danger" v-ripple>غیرفعال کردن</button>
                                </div>
                            </template>
                        </b-table>
                    </div>
                    <page-number :lengthList="lengthList" v-if="listCode.length" @callBack="getAllOfferCode" />

                </div>
            </div>

        </div>
    </section>
</template>

<script>
export default {
  name: 'page-dashbord-offercode',
  data () {
    return {
      isLoading: true,
      offerCodeForm: {
        code: '',
        off_capacity: '',
        off_percentage: '',
        course: ''
      },
      list: [],
      lengthList: 10,
      listCode: [],
      fieldsItems: [
        { key: 'course_title', label: 'نام دوره' },
        { key: 'code', label: 'کد تخفیف' },
        { key: 'reason', label: 'مناسبت' },
        { key: 'off_capacity', label: 'ظرفیت' },
        { key: 'off_percentage', label: 'درصد' },
        { key: 'action', label: 'عملیات' }
      ]
    }
  },
  computed: {},
  mounted () {
    this.getAllOfferCode(1)
    this.getMyCourse()
  },
  methods: {
    async getMyCourse () {
      try {
        this.isLoading = true
        let { data } = await axios.post('/course/get-my-course-list')
        if (data.state !== 200) return
        this.list = data.course_list
        this.isLoading = false
      } catch (error) {
        console.log(error)
      }
    },
    async getAllOfferCode (q) {
      let { data } = await axios.post('/offcode/get-all', { page_num: q })
      if (data.state !== 200) return
      this.lengthList = data.codes.length
      if (!data.codes.length) return
      this.listCode = data.codes
    },
    async remove (row) {
      let { data } = await axios.post('/offcode/disable-code', { id: row.item.id })
      if (data.state !== 200) return
      this.$root.showSuccessMsg({
        message: 'با موفقیت انجام شد...'
      })
      this.getAllOfferCode(1)
    },
    async submitForm () {
      let result = await this.$validator.validate()
      if (!result) {
        this.$root.showWarnMsg({
          message: 'لطفا فرم را تکمیل کنید ... '
        })
        return
      }
      let body = {
        code: 'T-' + this.offerCodeForm.code,
        course: parseInt(this.offerCodeForm.course),
        off_capacity: parseInt(this.offerCodeForm.off_capacity),
        off_percentage: parseInt(this.offerCodeForm.off_percentage)
      }
      let { data } = await axios.post('/offcode/new', body)

      if (data.state !== 200) {
        if (data.state == 400) {
          this.$root.showWarnMsg({
            message: 'کد نباید تکراری باشد'
          })
        }
        return
      }
      this.$store.commit('notifications/success', {
        message: this.$t('message.request.done'),
        title: ''
      })
      this.offerCodeForm = {
        code: '',
        off_capacity: '',
        off_percentage: '',
        course: ''
      }
      this.$validator.reset()
      this.getAllOfferCode(1)
    }
  }
}
</script>

<style lang="less">
@import (reference) "../../assets/css/variable.less";
.page-dashbord-offercode {
  .box-clear;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/offercode.vue